import axios from '@/assets/js/axios.js'
import { RULE_ENGINE_API } from './apis'
// 创建规则
export function createrules (params) {
  return axios.post(RULE_ENGINE_API.ADD, { params }).then(res => res.data)
}
// 规则列表
export function getrules (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/rules', { params }).then(res => res.data)
}

// 启停规则
export function startmode (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/start', { params }).then(res => res.data)
}

// 删除规则
export function deleteRule (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/delete', { params }).then(res => res.data)
}

// 规则触发
export function triggerRule (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/trigger', { params }).then(res => res.data)
}

// 规则详情
export function ruleDetaile (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/rule', { params }).then(res => res.data)
}

// 编辑规则
export function editeRule (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/update', { params }).then(res => res.data)
}
// 产品列表
export function listProduct (params) {
  return axios.post('/api/paas-platform/paas-business/v1/productManage/product/listProduct', { params }).then(res => res.data)
}
// 设备列表
export function deviceList (params) {
  return axios.post('/api/paas-platform/paas-business/v1/productManage/product/deviceList', { params }).then(res => res.data)
}

// 属性列表
export function getProductProp (params) {
  return axios.post('/api/paas-platform/paas-business/v1/modelManage/getThingModel', { params }).then(res => res.data)
}

// 日志列表
export function logList (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/execution/logs', { params }).then(res => res.data)
  //                      iot-platform/product-manage-service/v1
}

// 日志详情
export function logDetaile (params) {
  return axios.post('/api/paas-platform/paas-business/v1/rules/scene/execution/log', { params }).then(res => res.data)
}
